import React from 'react';
import { bool, func, number, object, oneOf, string } from 'prop-types';
import defaultClasses from './toast.module.css';
import { useStyle } from '../../classify';
import Icon from '../Icon';
import { X as CloseIcon } from 'react-feather';

var Toast = function Toast(props) {
  var actionText = props.actionText,
      dismissable = props.dismissable,
      hasDismissAction = props.hasDismissAction,
      dismissActionText = props.dismissActionText,
      icon = props.icon,
      message = props.message,
      onAction = props.onAction,
      handleAction = props.handleAction,
      onDismiss = props.onDismiss,
      handleDismiss = props.handleDismiss,
      type = props.type;
  var classes = useStyle(defaultClasses, {});
  var iconElement = icon ? React.createElement(React.Fragment, null, icon) : null;
  var controls = onDismiss || dismissable ? React.createElement("button", {
    className: classes.dismissButton,
    onClick: handleDismiss
  }, React.createElement(Icon, {
    src: CloseIcon,
    attrs: {
      width: 14
    }
  })) : null;
  var dismissActionButton = hasDismissAction && (onDismiss || dismissable) ? React.createElement("button", {
    className: classes.actionButton,
    onClick: handleDismiss
  }, dismissActionText) : null;
  var actions = onAction ? React.createElement("div", {
    className: classes.actions
  }, dismissActionButton, React.createElement("button", {
    className: classes.actionButton,
    onClick: handleAction
  }, actionText)) : null;
  return React.createElement("div", {
    className: classes["".concat(type, "Toast")]
  }, React.createElement("span", {
    className: classes.icon
  }, iconElement), React.createElement("div", {
    className: classes.message
  }, message), React.createElement("div", {
    className: classes.controls
  }, controls), actions);
};

Toast.propTypes = {
  actionText: string,
  dismissable: bool,
  icon: object,
  id: number,
  message: string.isRequired,
  onAction: func,
  onDismiss: func,
  handleAction: func,
  handleDismiss: func,
  type: oneOf(['info', 'warning', 'error', 'success']).isRequired
};
export default Toast;